import { useState, type FormEvent } from 'react';

import type { AuthUser } from '@lexio/shared';

import { BuildStamp } from '../components/BuildStamp';
import { login } from '../lib/api';

interface Props {
  onLoggedIn: (user: AuthUser) => void;
}

export function Login({ onLoggedIn }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const { user } = await login(email, password);
      onLoggedIn(user);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Přihlášení se nezdařilo');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="app">
      <div className="build-bar">
        <BuildStamp />
      </div>
      <div className="login">
      <h1 className="logo">Lexio</h1>
      <p className="muted">Dril anglické slovní zásoby</p>

      <form onSubmit={submit}>
        <input
          className="input"
          type="email"
          placeholder="E-mail"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          className="input"
          type="password"
          placeholder="Heslo"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="error">{error}</p>}
        <button className="btn primary" type="submit" disabled={busy}>
          {busy ? 'Přihlašuji…' : 'Přihlásit se'}
        </button>
      </form>

      <p className="muted small hint desktop-only">
        Účet se zakládá na serveru příkazem <code>npm run user:create</code>.
      </p>
      </div>
    </div>
  );
}
